import log from 'salvo-lite/log'
import cssClasses from '../helpers/cssClasses'
import {on} from '../helpers/utils'

class Login {
    constructor (components) {
        this._name = this.constructor.name
        this._components = components
    }

    onInit () {
        log.debug(this._name, 'Initializing', this)

        this._accountAlreadyExists()
        this._nodeSelectors = {
            customerLoginForm: document.querySelector('[js-password-form="customerLoginForm"]'),
            cancelPasswordLink: document.querySelector('[js-password-form="cancelPasswordLink"]'),
            recoverPasswordForm: document.querySelector('[js-password-form="recoverPasswordForm"]'),
            resetPasswordSuccess: document.querySelector('[js-password-form="resetPasswordSuccess"]'),
            forgotPasswordLink: document.querySelector('[js-password-form="forgotPasswordLink"]')
        }

        this._addEvents()

        if (this._nodeSelectors.recoverPasswordForm) {
            this._checkUrlHash()
            this._resetPasswordSuccess()
        }

        log.debug(this._name, 'Initiated', this)
    }

    /**
     * Add event listeners to toggle elements.
     */
    _addEvents () {
        log.debug(this._name, 'Adding Events')
        on('click', this._nodeSelectors.forgotPasswordLink, (event) => this._handlePasswordToggle(event))
        on('click', this._nodeSelectors.cancelPasswordLink, (event) => this._handlePasswordToggle(event))
    }

    /**
     * Handle login and forgot password form toggle.
     */
    _handlePasswordToggle (event) {
        event.preventDefault()
        this._toggleRecoverPasswordForm()
    }

    /**
     * Check if #recover is in url hash.
     * - This can occur when the user is coming from an external source.
     */
    _checkUrlHash () {
        const hash = window.location.hash

        // Allow deep linking to recover password form
        if (hash === '#recover') this._toggleRecoverPasswordForm()
    }

    /**
     *  Show/Hide recover password form
     */
    _toggleRecoverPasswordForm () {
        this._nodeSelectors.recoverPasswordForm.classList.toggle(cssClasses.hidden)
        this._nodeSelectors.customerLoginForm.classList.toggle(cssClasses.hidden)
    }

    /**
     *  Show reset password success message
     */
    _resetPasswordSuccess () {
        // check if reset password form was
        // successfully submitted and show success message.

        if (!this._nodeSelectors.resetPasswordSuccess) return
        this._nodeSelectors.resetPasswordSuccess.classList.remove(cssClasses.hidden)
    }

    /**
     * Show "Account Already Exists" text if URL contains appropriate query
     */
    _accountAlreadyExists () {
        const redText = document.querySelector('.red-text')
        if (window.location.href.indexOf('%3Faccountexists') > -1) {
            redText.style.display = 'block'
        }
    }
}

export default Login



// WEBPACK FOOTER //
// ./src/resources/scripts/pages/Login.js